import type { Environment } from "./environment.model";

export const environment: Environment = {
    envName: "development",
    apiKey: "4_OelYUaRMHr1uElXNoK7Htw",
    nsgoApiKey: "4_OelYUaRMHr1uElXNoK7Htw",
    fallbackUrlB2B: "https://www.test.ns.nl/zakelijk/mijnns",
    fallbackUrlB2C: "https://www.test.ns.nl/mijnns",
    fallbackNsgo: "https://nsgo.ns.nl/inloggen",
    gigyaApiDomainsByHostname: {
        "logintestzakelijk.ns.nl": "https://id.logintestzakelijk.ns.nl",
        // Only affects which CDN the gigya[.oidc].js FILE is fetched from - does NOT
        // change where the SDK sends accounts.* REST calls. The SDK derives that
        // domain internally as id.<window.location.hostname> regardless of this
        // config (confirmed live: window.__gigyaConf.apiDomain was correctly set to
        // id.logintestzakelijk.ns.nl, but accounts.login still POSTed to
        // id.localhost and failed with ERR_CONNECTION_REFUSED). Real accounts.*
        // calls - including a real CAPTCHA solve - cannot be exercised from bare
        // localhost; test those against the deployed logintestzakelijk.ns.nl.
        "localhost": "https://id.logintestzakelijk.ns.nl"
    },
    gigyaApiDomainNsgo: "https://id.logintestnsgo.ns.nl",
    resendActivationEmailUrl: "https://gateway.apiportaltst.ns.nl/nsbusiness/resendactivationemail",
    resendActivationEmailSubscriptionKey: "b671932acf89432d919196b105020dfe",
    invitationApiUrl: "https://gateway.apiportaltst.ns.nl/login",
    invitationApiSubscriptionKey: "6030f8d9e3084aa6853ca1d2c29f6863",
    nativeAppOidcClientId: "CeQ6E6_rEsJQpn5uoZN0GNVy",
    // reCAPTCHA v2 site key, scoped to logintestzakelijk.ns.nl + localhost.
    // TODO: this is currently the INVISIBLE-type key; the visible checkbox fallback needs a
    // CHECKBOX-type v2 key here (Google rejects an invisible key rendered as a checkbox).
    // Its matching secret key belongs only in the test tenant's CDC Console - never here.
    recaptchaSiteKey: "6Ldr58ctAAAAANpkGV0c13HCxGKbNbMBYXZm5NSV",
    // TODO: reCAPTCHA v3 site key (a v3-type key, scoped to logintestzakelijk.ns.nl +
    // localhost, its secret in the test tenant's CDC Console). While empty the login
    // page stays on the v2-only flow above.
    recaptchaV3SiteKey: "6LcSxMctAAAAAI5tUQ1ovZdrHpWVM-RDg8ZDJZuB"
};
